import { Controller } from "@hotwired/stimulus";
import consumer from "../channels/consumer";

export default class extends Controller {
  static targets = ["badge"];
  static values = { projectId: Number, status: String };

  connect() {
    if (!this.hasProjectIdValue) return;
    this.subscription = consumer.subscriptions.create(
      { channel: "ProjectChannel", project_id: this.projectIdValue },
      { received: (data) => this.#update(data) },
    );
  }

  disconnect() {
    this.subscription?.unsubscribe();
  }

  #update(data) {
    if (!data.status || !this.hasBadgeTarget) return;

    const previous = this.statusValue;
    if (previous !== data.status) {
      this.dispatch("statusChanged", {
        detail: { previous, next: data.status },
        prefix: "project-status",
      });
      this.statusValue = data.status;
    }

    this.badgeTarget.textContent = data.status.charAt(0).toUpperCase() + data.status.slice(1);
    this.badgeTarget.className = `badge badge--${this.#badgeClass(data.status)}`;
  }

  #badgeClass(status) {
    return { completed: "success", rendering: "warning", failed: "error", draft: "info" }[status] || "info";
  }
}
